import React from "react";
import { LanguageCode } from "../../utils/translations";
import { getUseCase } from "../../features/usecases/useCaseContent";

interface SocialMediaAutomationProps {
  lang?: LanguageCode;
}

const SocialMediaAutomation: React.FC<SocialMediaAutomationProps> = ({
  lang = "en",
}) => {
  const content = getUseCase(lang, "socialAutomation");

  return (
    <div style={{ padding: "40px 8%", maxWidth: "1000px", margin: "auto" }}>
      <h1>{content.title}</h1>

      <p>{content.intro}</p>

      {content.sections.map((section) => (
        <React.Fragment key={section.heading}>
          <h2>{section.heading}</h2>
          {section.body && <p>{section.body}</p>}
          {section.items && (
            <ul>
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SocialMediaAutomation;
